export default __webpack_public_path__ + "static/media/errorpage.45429ceb.svg";